import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit';
import i18n from 'i18n';
import axios from 'axios';
import { setDefaultSettings } from './fuse/settingsSlice';
import client from 'client';
import i18next from 'i18next';

// Crear un thunk para cargar las traducciones desde el backend
export const fetchTranslations = createAsyncThunk(
  'i18n/fetchTranslations',
  async (languageId, { dispatch }) => {
    try {
      console.log('Cargando traducciones para el idioma:', languageId);
      // Hacer la petición al backend
      const response = await client.get(`/language-translation/language/${languageId}`);
      const translations = await response.data;
      
      // Añadir las traducciones al i18next
      i18next.addResourceBundle(languageId, 'navigation', translations);
      
      return languageId;
    } catch (error) {
      console.error('Error al cargar traducciones:', error);
      throw error;
    }
  }
);

// Modificar la función changeLanguage para usar el nuevo thunk
// Modificar la función changeLanguage para asegurarse de que actualiza el estado correctamente
export const changeLanguage = (languageId) => async (dispatch, getState) => {
  console.log('Changing language to:', languageId);
  
  const { direction } = getState().fuse.settings.defaults;
  const newLangDirection = i18n.dir(languageId);
  
  try {
    // Actualizar dirección si es necesario
    if (newLangDirection !== direction) {
      dispatch(setDefaultSettings({ direction: newLangDirection }));
    }
    
    // Cargar traducciones primero
    await dispatch(fetchTranslations(languageId)).unwrap();
    
    // Cambiar el idioma en i18n
    await i18n.changeLanguage(languageId);
    
    // Actualizar el estado después de que todo esté listo
    dispatch(i18nSlice.actions.languageChanged(languageId));
    
    console.log('Language changed successfully to:', languageId);
    
    return true;
  } catch (error) {
    console.error('Error changing language:', error);
    return false;
  }
};

// Crear el slice con estado adicional para tracking de carga
const i18nSlice = createSlice({
  name: 'i18n',
  initialState: {
    language: i18n.options.lng,
    isLoading: false,
    isInitialized: false,
    error: null,
  },
  reducers: {
    languageChanged: (state, action) => {
      state.language = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTranslations.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchTranslations.fulfilled, (state) => {
        state.isLoading = false;
        state.isInitialized = true;
      })
      .addCase(fetchTranslations.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

console.log('i18nSlice---------');

export const selectCurrLangDir = createSelector(
  [({ i18n: i18nState }) => i18nState.language],
  (language) => {
    return i18n.dir(language);
  }
);

// Selector para conocer si las traducciones están cargando
export const selectIsTranslationsLoading = (state) => state.i18n.isLoading;

// Selector para conocer si las traducciones están inicializadas
export const selectIsTranslationsInitialized = (state) => state.i18n.isInitialized;

export default i18nSlice.reducer;